module.exports = __webpack_public_path__ + "static/media/ludoBoard.ad965042.png";